import React from 'react'
import PropTypes from "prop-types";
import PasswordInputComponent from "./PasswordInputComponent";
import UserDataService from "../../common/UserDataService";
import EmailInputComponent from "./EmailInputComponent";
import NameInputComponent from "./NameInputComponent";
import {fetchResponseHandler} from "../../../util/FetchUtil";
import {setupOnExtractData} from "../../../util/FormUtil";
import {isNotBlank} from "../../../util/StringUtil";
import UpdateUserNameAsEmailInputComponent from "./UpdateUserNameAsEmailInputComponent";

const PROP_NAME_PASSWORD = "password";
const PROP_NAME_CONFIRM_PASSWORD = "confirmPassword";
const PROP_NAME_FIRST_NAME = "firstName";
const PROP_NAME_LAST_NAME = "lastName";
const PROP_NAME_EMAIL = "email";

class LoginContactInfoInputComponent extends React.Component {
    constructor(props) {
        super(props);
        this.findCalcs = this.findCalcs.bind(this);
        this.extractData = this.extractData.bind(this);
        this.setExtractEmailInfo = this.setExtractEmailInfo.bind(this);
        this.setExtractPasswordInfo = this.setExtractPasswordInfo.bind(this);
        this.setExtractNameInfo = this.setExtractNameInfo.bind(this);
        this.setExtractUsernameUpdateInfo = this.setExtractUsernameUpdateInfo.bind(this);
    }

    componentDidMount() {
        setupOnExtractData(this);
    }

    extractData() {
        let result = {};

        const {hideEmail, hidePassword, hideName, hideUserName = true} = this.props;
        if (!hideEmail) {
            result.emailInfo = this.extractEmailInfo();
        }
        if (!hidePassword) {
            result.passwordInfo = this.extractPasswordInfo();
        }
        if (!hideName) {
            result.nameInfo = this.extractNameInfo();
        }
        if (!hideUserName) {
            result.updateUserNameSameAsEmail = this.extractUsernameUpdateInfo();
        }

        return result;
    };

    setExtractEmailInfo(func) {
        this.extractEmailInfo = func;
    }

    setExtractPasswordInfo(func) {
        this.extractPasswordInfo = func;
    }

    setExtractNameInfo(func) {
        this.extractNameInfo = func;
    }

    setExtractUsernameUpdateInfo(func) {
        this.extractUsernameUpdateInfo = func;
    }

    findCalcs(passwordMetadata, changedField, changedValue) {
        const {userDataService, setFormState, data, metadata} = this.props;

        //If password isnt populated (profile scenario) dont bother running the calcs.
        if ((changedField === PROP_NAME_PASSWORD && isNotBlank(changedValue)) || isNotBlank(data[PROP_NAME_PASSWORD])) {
            let body = {
                password: data[PROP_NAME_PASSWORD] ? data[PROP_NAME_PASSWORD] : "",
                userName: data[PROP_NAME_EMAIL] ? data[PROP_NAME_EMAIL] : "",
                firstName: data[PROP_NAME_FIRST_NAME] ? data[PROP_NAME_FIRST_NAME] : "",
                lastName: data[PROP_NAME_LAST_NAME] ? data[PROP_NAME_LAST_NAME] : ""
            };
            body[changedField] = changedValue;
            userDataService.findCalcs(
                body
            )
                .then(fetchResponseHandler)
                .then(resp => {
                    let isValid = true;
                    Object.entries(resp).forEach(e => {
                        isValid = isValid && e[1]
                    });
                    let message = null;
                    if (!isValid) {
                        message = "Password does not satisfy the password complexity rule."
                    }
                    const finalMetadata = passwordMetadata ? {
                            ...passwordMetadata,
                            valid: isValid,
                            calcs: resp,
                            message: message
                        }
                        : {valid: isValid, calcs: resp, message: message}
                    setFormState({property: PROP_NAME_PASSWORD, metadata: finalMetadata});
                })
        }
    }

    render() {
        const {
            data,
            hideEmail, hidePassword, hideName, hideUserName = true,
            inRegistration, isEmailEditable = true, isNameEditable = true,
            oldEmailSameAsUserName, metadata, passwordRequired, passwordPlaceholder = '',
            setFormState, setPageError, userDataInit, userDataService, isUpdatePassword
        } = this.props;

        return (
            <div>
                {
                    !hideName &&
                    <NameInputComponent
                        data={data}
                        isEditable={isNameEditable}
                        metadata={metadata}
                        setFormState={setFormState}
                        userDataInit={userDataInit}
                        findCalcs={this.findCalcs}
                        onExtractData={this.setExtractNameInfo}
                    />
                }
                {
                    !hideEmail &&
                    <EmailInputComponent
                        data={data}
                        isEditable={isEmailEditable}
                        metadata={metadata}
                        setFormState={setFormState}
                        userDataInit={userDataInit}
                        userDataService={userDataService}
                        findCalcs={this.findCalcs}
                        onExtractData={this.setExtractEmailInfo}
                        setPageError={setPageError}
                        inRegistration={inRegistration}
                    />
                }
                {
                    !hideUserName &&
                    <UpdateUserNameAsEmailInputComponent
                        data={data}
                        oldEmailSameAsUserName={oldEmailSameAsUserName}
                        onExtractData={this.setExtractUsernameUpdateInfo}
                        setFormState={setFormState}
                        userDataService={userDataService}
                    />
                }
                {
                    !hidePassword &&
                    <PasswordInputComponent
                        data={data}
                        metadata={metadata}
                        setFormState={setFormState}
                        userDataInit={userDataInit}
                        userDataService={userDataService}
                        findCalcs={this.findCalcs}
                        onExtractData={this.setExtractPasswordInfo}
                        required={passwordRequired}
                        placeholder={passwordPlaceholder}
                        isUpdatePassword={isUpdatePassword}
                    />
                }
            </div>
        );
    }
}

LoginContactInfoInputComponent.propTypes = {
    // This is the object that contains properties like country, address, etc
    data: PropTypes.object.isRequired,
    hideEmail: PropTypes.bool,
    hideName: PropTypes.bool,
    hidePassword: PropTypes.bool,
    hideUserName: PropTypes.bool,
    isEmailEditable: PropTypes.bool,
    isNameEditable: PropTypes.bool,
    metadata: PropTypes.object.isRequired,
    oldEmailSameAsUserName: PropTypes.bool,
    // This is the function to set properties of the "data" object. The function should take property name as first parameter and the value as the second parameter.
    setFormState: PropTypes.func.isRequired,
    userDataInit: PropTypes.object.isRequired,
    userDataService: PropTypes.instanceOf(UserDataService).isRequired,
    onExtractData: PropTypes.func.isRequired,
    setPageError: PropTypes.func.isRequired,
    passwordPlaceholder: PropTypes.string,
    passwordRequired: PropTypes.bool,
    inRegistration: PropTypes.bool,
    isUpdatePassword: PropTypes.bool
}

export default LoginContactInfoInputComponent;

